import { useEffect, useState } from 'react';

import { getImageFromCacheAsync, getImageFromCacheSync } from '../../lib/imageCache';

import { useMount } from '../../hooks/useMount';
import { useBaseUrl } from '../../store/SelectedHomeyStore.hooks';

import generic_device from '../../components/controls/images/sensor/generic-device.svg';

import { Glyph } from './Glyph';

export function HomeyIcon(props) {
  const { baseUrl } = useBaseUrl();
  const [state, setState] = useState(() => {
    // Attempt to read sync. If it fails the useEffect behavior always runs.
    const image = getImageFromCacheSync({ id: props.iconObj?.id });

    if (image != null) {
      return image.src;
    }

    return null;
  });
  const mount = useMount();

  useEffect(() => {
    function setStateIfNotEqual(nextState) {
      setState((prevState) => {
        if (nextState === prevState) {
          return prevState;
        }

        return nextState;
      });
    }

    // Not sure why they can be empty strings but it happens.
    if (props.iconObj?.id != null && baseUrl != null) {
      const iconId = props.iconObj.id;
      const baseSrc = `https://icons-cdn.athom.com/${props.iconObj.id}.svg?ver=1`;
      const nextSrc = `${baseUrl}${props.iconObj.url}`;

      (async () => {
        // Await should wrap any non-promise value.
        const image = await getImageFromCacheAsync({
          id: iconId,
          baseSrc: baseSrc,
          nextSrc: nextSrc,
        });

        if (mount.isMounted) {
          setStateIfNotEqual(image.src);
        }
      })().catch((error) => {
        console.log(error);
        setStateIfNotEqual(generic_device);
      });
    }

    if (props.iconObj?.id == null) {
      setStateIfNotEqual(generic_device);
    }
  }, [baseUrl, props.iconObj, mount]);

  return (
    <Glyph source={state ?? ''} color={props.color} size={props.size} className={props.className} />
  );
}
